import { React } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import packageJson from '../../package.json';
import { useConfig } from 'contexts/ConfigContext';

export function About() {

  const { t } = useTranslation();
  const { configData } = useConfig();

  return (
      <Container style={{ maxWidth: '570px' }}>
        <h2 className="mt-4">{t('about')}</h2>
              <Row>
              <Col>
         <p>v.web: {packageJson.version}</p>
                      <p>v.API: {configData.versionApi}</p>
                  </Col>
                  </Row>
      </Container>
  );
}
